import Layout from '@layout/Index'

export const taskOrder = [
  {
    path: '/task-order',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "task-order-table" */ './pages/TaskOrderTable.vue'),
        name: '任务工单列表',
        meta: {
          title: '任务工单列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/task-order/task-order.route.js